import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { TableViewContainer } from './styles';
import { TableArrow, useTableArrow } from './tableArrow';
import LabelTag from '../../../components/LabelTag';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS, useDocumentContext } from '../../../context/complexDocumentContext';
import { getAllBlocks } from './index';
import { CONTEXT_KEYS, useArtboardContext } from '../../../context/complexArtboardContext';
import { scrollToElement } from '../../../utils/groupHelper';
import { deepCopy } from '../../../utils/javascript';
import { BUSINESS_LOGIC_TAB } from '../translationValues';

export const TableView = ({ tableHeadData = [], tableBodyData = [], ...props }) => {
  const { rulesList, variablesList, isEditMode, isBlockLogic, isElementLogic, isFlowLogic, t, setRulesList, onSave } = props;
  const { showTableArrow, setshowTableArrow, tableScrollRef } = useTableArrow();
  const [isGroupRemoved, setIsGroupRemoved] = useState(false);

  const contextSelector = useCallback(store => store, []);
  const [documentContext, methods] = useDocumentContext(contextSelector);

  const artboardContextSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign, updateArtboard] = useArtboardContext(artboardContextSelector);
  
  useEffect(() => {
    if (isGroupRemoved) {
      onSave && onSave();
      setIsGroupRemoved(false);
    }
  }, [isGroupRemoved]);

  const viewTableContainerClass =
    rulesList.length > 2 ? 'table-three-colum' : rulesList.length > 1 ? 'table-two-column' : '';

  const rowSpannedIndex = [];

  const { allGroups } = useMemo(() => getAllBlocks(documentContext, true), []);

  const handleTagClick = (tagInfo) =>{
    scrollToElement(tagInfo);
  }

  const handleRemove = id => {
    const rule = deepCopy(rulesList[0]);
    const existingGroupMap = documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.ELEMENT_GROUPS];
    const groupDetail = existingGroupMap.get(id);
    existingGroupMap.set(id, {groupName: groupDetail.groupName, isBLPresent: false})
    rule.groupIDs = rule.groupIDs.filter(item => item !== id);
    setRulesList([rule]);
    setIsGroupRemoved(true);
  };

  const [flowUUID, blockUUID] = useMemo(() => {
    const flowId = rulesList?.[0]?.flowId;
    if (!flowId) {
      return ['', ''];
    }
    const backendIds = documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.PERSISTED_KEYS];
    const key = Object.keys(backendIds).find(key => backendIds[key] === flowId);
    const isFlow = methods.get()[key];
    if (key && isFlow) {
      const blockUUIDs = isFlow[`${key}-0`];
      if (blockUUIDs?.length > 0) {
        return [key, blockUUIDs[0]];
      }
      return [key, ''];
    }
    return ['',''];
  }, [rulesList, documentContext]);

  return (
    <TableViewContainer
      className={viewTableContainerClass}
      style={{ overflowX: rulesList.length > 3 ? 'auto' : '' }}
      onMouseEnter={() => setshowTableArrow(true)}
      onMouseLeave={() => setshowTableArrow(false)}
      ref={tableScrollRef}
      show={!isEditMode}
    >
      <table>
        {isBlockLogic && tableHeadData.length > 2 && <thead>
          <tr>{tableHeadData.map((item, index) => (index !== 0 ? <th>{item}</th> : <></>))}</tr>
        </thead>}
        <tbody>
          {tableBodyData.map(bodyItem => {
            return (
              <tr>
                {bodyItem.map((rowItem, rowIndex) => {
                  if (rowIndex === 0) {
                    return null;
                  } else if (!rowSpannedIndex.includes(rowIndex)) {
                    const rule = rulesList.find(item => item.id === rowItem.ruleId);
                    if (rule?.ruleText) {
                      rowSpannedIndex.push(rowIndex);
                      return <td>{rule.ruleText}</td>;
                    }
                    return null;
                  }
                  return null;
                })}
              </tr>
            );
          })}
          <tr style={{background: 'white', fontSize:'18px', fontWeight:'bold', textAlign:'center', cursor: isFlowLogic && flowUUID && 'pointer'}} onClick={() => isFlowLogic && flowUUID && scrollToElement({flowUUID, blockUUID, scrollToPage: true})}>
          {isFlowLogic ?
           <span>
                {t(
                  BUSINESS_LOGIC_TAB.NAVIGATE_TO_PAGE.key,
                  BUSINESS_LOGIC_TAB.NAVIGATE_TO_PAGE.value,
                )}
            </span> : null}</tr>
          <tr style={{ background: 'white', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          {!isBlockLogic && isElementLogic && rulesList.length > 0 && rulesList[0].groupIDs && rulesList[0].groupIDs.map((id, i) => {
            const tagInfo = allGroups.find(g => g?.groupId === id);
            return tagInfo ? <LabelTag key={i} tagInfo={tagInfo} popConfirmTitle={'Are you sure to delete?'} t={t} handleTagClick={handleTagClick} onRemove={handleRemove} isInteractiveDesign={isInteractiveDesign} /> : null
          })}
          </tr>
        </tbody>
        {showTableArrow && rulesList.length > 3 ? (
          <TableArrow tableScrollRef={tableScrollRef} />
        ) : (
          <></>
        )}
      </table>
    </TableViewContainer>
  );
};
